import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { FileTextIcon, CalendarIcon, CheckSquareIcon, ShieldIcon, MoonIcon } from 'lucide-react';
export function IncludesSection() {
  return <section className="w-full px-6 py-16 md:py-20" data-id="element-176">
      <div className="max-w-2xl mx-auto" data-id="element-177">
        <AnimatedSection data-id="element-178">
          <div className="w-12 h-px bg-sand mx-auto mb-12" data-id="element-179" />
        </AnimatedSection>

        <AnimatedSection data-id="element-180">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal leading-tight mb-10" data-id="element-181">
            Lo que incluye<span className="text-teal" data-id="element-182">.</span>
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={0.1} data-id="element-183">
          <div className="space-y-5" data-id="element-184">
            <div className="flex items-start gap-4 bg-white/60 rounded-xl p-5 border border-cream-dark/50" data-id="element-185">
              <div className="w-10 h-10 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-186">
                <FileTextIcon className="w-5 h-5 text-teal" data-id="element-187" />
              </div>
              <div data-id="element-188">
                <p className="text-charcoal font-medium text-base md:text-lg" data-id="element-189">
                  PDF completo "RESET 48"
                </p>
                <p className="text-warm-gray text-sm mt-1" data-id="element-190">
                  El protocolo paso a paso, sin relleno.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white/60 rounded-xl p-5 border border-cream-dark/50" data-id="element-191">
              <div className="w-10 h-10 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-192">
                <CalendarIcon className="w-5 h-5 text-teal" data-id="element-193" />
              </div>
              <div data-id="element-194">
                <p className="text-charcoal font-medium text-base md:text-lg" data-id="element-195">
                  Plan 48h en bloques de 10–20 minutos
                </p>
                <p className="text-warm-gray text-sm mt-1" data-id="element-196">
                  Porque no tienes 4 horas seguidas. Y no las necesitas.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white/60 rounded-xl p-5 border border-cream-dark/50" data-id="element-197">
              <div className="w-10 h-10 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-198">
                <CheckSquareIcon className="w-5 h-5 text-teal" data-id="element-199" />
              </div>
              <div data-id="element-200">
                <p className="text-charcoal font-medium text-base md:text-lg" data-id="element-201">
                  Checklists imprimibles
                </p>
                <p className="text-warm-gray text-sm mt-1" data-id="element-202">
                  Modo normal + modo emergencia. Para días buenos y días
                  difíciles.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white/60 rounded-xl p-5 border border-cream-dark/50" data-id="element-203">
              <div className="w-10 h-10 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-204">
                <ShieldIcon className="w-5 h-5 text-teal" data-id="element-205" />
              </div>
              <div data-id="element-206">
                <p className="text-charcoal font-medium text-base md:text-lg" data-id="element-207">
                  Protocolo de recaída
                </p>
                <p className="text-warm-gray text-sm mt-1" data-id="element-208">
                  15 minutos para cuando todo se vuelve a caer. Porque va a
                  pasar — y está bien.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white/60 rounded-xl p-5 border border-cream-dark/50" data-id="element-209">
              <div className="w-10 h-10 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-210">
                <MoonIcon className="w-5 h-5 text-teal" data-id="element-211" />
              </div>
              <div data-id="element-212">
                <p className="text-charcoal font-medium text-base md:text-lg" data-id="element-213">
                  Cierre nocturno (12 minutos)
                </p>
                <p className="text-warm-gray text-sm mt-1" data-id="element-214">
                  Para que no amanezca peor de como te dormiste.
                </p>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}